import { render, staticRenderFns } from "./leaves.vue?vue&type=template&id=71ff1797&scoped=true"
import script from "./leaves.vue?vue&type=script&lang=js"
export * from "./leaves.vue?vue&type=script&lang=js"
import style0 from "./leaves.vue?vue&type=style&index=0&id=71ff1797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff1797",
  null
  
)

export default component.exports